module.exports = __webpack_public_path__ + "static/media/6_l_provoda_0_5.28.6fe654e8.png";